// The public page list, in a module of its own so the admin console can read
// it without importing site.js -- which imports main.js, which imports
// site.js. That cycle resolves only because main.js is the entry point, and
// breaks with "Cannot access 'PAGES' before initialization" the moment
// anything else is imported first.
export const PAGES = [
  { id: 'home', path: '/', label: 'Home' },
  { id: 'camps', path: '/camps', label: 'Health camps' },
  { id: 'events', path: '/events', label: 'Events' },
  { id: 'gallery', path: '/gallery', label: 'Gallery' },
  { id: 'cultural', path: '/cultural', label: 'Sports & culture' },
  { id: 'contact', path: '/contact', label: 'Contact' },
];

// Home is never hidden -- it is the site. Everything else can be switched off
// from /admin without losing its content.
export function visiblePages(settings) {
  const hidden = new Set(settings?.hiddenPages ?? []);
  return PAGES.filter((p) => p.id === 'home' || !hidden.has(p.id));
}

export function isHidden(settings, id) {
  return id !== 'home' && (settings?.hiddenPages ?? []).includes(id);
}
